// React
import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";

// Bootstrap Components
import { Nav, Navbar, NavItem, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// AWS
import { Auth } from "aws-amplify";

function TopBar(props) {
  async function handleLogout() {
    // await Auth.signOut();

    // props.userHasAuthenticated(false);

    props.history.push("/login");
  }

  return (
    !props.authData && (
      <div className="topNav">
        <Navbar expand="md">
          <Navbar.Brand as={Link} to="/">Eventify</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {/* <Nav className="mr-auto">
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#link">Link</Nav.Link>
              <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            </Nav> */}
            <Nav className="justify-content-end">
              {props.authData ? (
                <Nav.Item onClick={handleLogout}>Logout</Nav.Item>
              ) : (
                <>
                  <Nav.Link as={Link} to="/signup">Signup</Nav.Link>
                  <Nav.Link as={Link} to="/login">Login</Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  );
}

export default TopBar;
